import { render } from "./ProductsManagement.html?vue&type=template&id=31364664&scoped=true"
import script from "./ProductsManagement.js?vue&type=script&lang=js"
export * from "./ProductsManagement.js?vue&type=script&lang=js"

import "./ProductsManagement.css?vue&type=style&index=0&id=31364664&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31364664"]])

export default __exports__